'use client'

import React, {createContext} from 'react'

type ValuePiece = Date | null;
type Value = ValuePiece | [ValuePiece, ValuePiece];

interface StayContextType {
	room: string,
	date: null | Value,
	guests: null | string,
	roomPackage: null | string,
	packageNightCount: null | number,
	setRoom: (room: string) => void,
	setDate: (date: string[]) => void,
	setGuests: (guests: string) => void,
	setRoomPackage: (roomPackage: string) => void,
	setPackageNightCount: (packageNightCount: number | null) => void,
	focusGuest: React.MutableRefObject<boolean>,
	mobileMenuOpen: boolean,
	setMobileMenuOpen: (mobileMenuOpen: boolean) => void,
}

const StayContext = createContext<StayContextType>({

	room: '',
	date: null,
	guests: '',
	roomPackage: '',
	packageNightCount: null,
	setRoom: () => {},
	setDate: () => {},
	setGuests: () => {},
	setRoomPackage: () => {},
	setPackageNightCount: () => {},
	focusGuest: {current: false},
	mobileMenuOpen: false,
	setMobileMenuOpen: () => {},
})

export default StayContext
